<template>
<div class="err-page-wrap">
  <div class="err-img">
    <img :src="errImg" alt="">
    <span class="text">网络加载失败，请点击返回</span>
    <mt-button class="button" type="default" @click="back">返回</mt-button>
  </div>
</div>
</template>

<script>
import {quit} from '../../../utils/h5ToAppHandler'
const errImg = require('../../../images/electronicLetter/no-network.png')
export default {
  name: 'errPage',
  data () {
    return { errImg }
  },
  methods: {
    back () {
      quit()
    }
  }
}
</script>

<style lang="scss" scoped>
.err-page-wrap {
  position: fixed;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: #fff;
  .err-img {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 170px;
    img {
      width: 90%;
      margin-bottom: 50px;
    }
    .text {
      font-size: 32px;
      color: #333;
      margin-bottom: 30px;
    }
    .button {
      height: 57px;
      width: 176px;
      border: 1px solid #ff6519;
      border-radius: 40px;
      color: #ff6519;
      background-color: #fff;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/electronicLetter/common/errPage.vue